import { AdminCatalogError, type AdminCatalogErrorCode } from './types';

const codes: Record<string, AdminCatalogErrorCode> = {
  'catalog-validation-error': 'validation-error',
  'category-conflict': 'version-conflict',
  'product-conflict': 'version-conflict',
  'category-slug-conflict': 'category-slug-conflict',
  'product-slug-conflict': 'product-slug-conflict',
  'sku-conflict': 'sku-conflict',
  'category-not-empty': 'category-not-empty',
  'product-not-publishable': 'not-publishable',
  'category-not-publishable': 'not-publishable',
  'invalid-category-state': 'invalid-lifecycle',
  'invalid-product-state': 'invalid-lifecycle',
  'published-slug-immutable': 'invalid-lifecycle',
  'published-sku-immutable': 'invalid-lifecycle',
  'category-not-found': 'not-found',
  'product-not-found': 'not-found',
  forbidden: 'forbidden',
  'service-unavailable': 'service-unavailable',
  'internal-error': 'service-unavailable',
};

export function createAdminCatalogError(input: {
  code?: string;
  status?: number;
  fieldErrors?: Record<string, string[]>;
  requestId?: string;
}) {
  const code = input.code ? (codes[input.code] ?? 'unknown') : 'unknown';
  const messages: Record<AdminCatalogErrorCode, string> = {
    'validation-error': 'Review the highlighted catalog fields.',
    'version-conflict': 'This record changed in another session.',
    'category-slug-conflict': 'Another category already uses this slug.',
    'product-slug-conflict': 'Another product already uses this slug.',
    'sku-conflict': 'Another product or variant already uses this SKU.',
    'category-not-empty': 'Archive or move published products before archiving this category.',
    'not-publishable': 'Complete the publication requirements before publishing.',
    'invalid-lifecycle': 'This lifecycle action is not available for the current status.',
    'not-found': 'The catalog record could not be found.',
    forbidden: 'Your account is not authorized to administer the catalog.',
    'network-error': 'The catalog service could not be reached.',
    'service-unavailable': 'The catalog service is temporarily unavailable.',
    unknown: 'The catalog request could not be completed.',
  };
  return new AdminCatalogError(
    code,
    messages[code],
    input.status,
    input.fieldErrors,
    input.requestId,
  );
}
